import type { JSX } from "preact";

type Variant = "primary" | "ghost" | "quiet";
type Size = "sm" | "md" | "lg";

type ButtonProps = {
  variant?: Variant;
  size?: Size;
  breathing?: boolean;
} & JSX.ButtonHTMLAttributes<HTMLButtonElement>;

export function Button({
  variant = "primary",
  size = "md",
  breathing,
  class: className,
  type = "button",
  children,
  ...rest
}: ButtonProps) {
  const cls = ["btn", `btn-${variant}`, `btn-${size}`, breathing && "btn-breathing", className as string]
    .filter(Boolean)
    .join(" ");
  return (
    <button class={cls} type={type} {...rest}>
      {children}
    </button>
  );
}
